import React from 'react'
// components
import ObjectSecurity from 'components/PageComponents/Settings/Security/components/ObjectSecurity'
import ObjectSecurityAPI from 'containers/Security/components/ObjectSecurity/layers/API'

const ObjectSecurityContainer: React.FC = () => {
  return (
    <ObjectSecurityAPI>
      <ObjectSecurity />
    </ObjectSecurityAPI>
  )
}

export default ObjectSecurityContainer
